import { FC } from "react";
import { GroupWrapper } from "./GroupWrapper";
import { Styled } from "../../types";
import {
  DETAILS_SECTION_STYLES,
  SECTION_TITLE_STYLES,
  SUB_HEADER_STYLES,
} from "../styles";
import { capitalizeAssociatedPress } from "../../../../helpers/string/capitalize";
import {
  ToggleModalButton,
  ToggleModalButtonProps,
} from "../../../../components/Interaction/Buttons/ToggleModalButton";

const setHeader = (title: string, isSubHeader = true) =>
  isSubHeader ? (
    <h3 className={SUB_HEADER_STYLES}>{title}</h3>
  ) : (
    <h2 className={SECTION_TITLE_STYLES}>{title}</h2>
  );

export const SubSectionWithStyles: FC<
  React.PropsWithChildren<
    Styled & {
      title: string;
      isSubHeader?: boolean;
      withGroup?: boolean;
      buttonProperties?: ToggleModalButtonProps;
    }
  >
> = ({
  title,
  isSubHeader = true,
  withGroup = true,
  children,
  className = "",
  buttonProperties,
}) => {
  return (
    <section className={`${DETAILS_SECTION_STYLES} ${className}`}>
      <header className="flex h-fit items-center justify-between">
        {setHeader(capitalizeAssociatedPress(title), isSubHeader)}
        {buttonProperties && <ToggleModalButton {...buttonProperties} />}
      </header>
      {withGroup ? <GroupWrapper>{children}</GroupWrapper> : children}
    </section>
  );
};
